module.exports = __webpack_public_path__ + "img/user-banner-white.71dda5be.png";